export const InvoiceFrequency = [
  {
    label: "End of month",
    secondaryLabel: "Monthly - Month End",
    value: "EndOfMonth"
  },
  {
    label: "7th of month",
    secondaryLabel: "Monthly - 7th",
    value: "SeventhOfMonth"
  },
  {
    label: "10th of month",
    secondaryLabel: "Monthly - 10th",
    value: "TenthOfMonth"
  },
  {
    label: "11th of month",
    secondaryLabel: "Monthly - 11th",
    value: "EleventhOfMonth"
  },
  {
    label: "15th of month",
    secondaryLabel: "Monthly - 15th",
    value: "FifteenthOfMonth"
  },
  {
    label: "21st of month",
    secondaryLabel: "Monthly - 21st",
    value: "TwentyFirstOfMonth"
  }
];
